import axios from "config/axios/base";
import qs from "qs";

export const getGlobals = ({ query = {}, options = null }) => axios.get(`/global-data?${qs.stringify(query)}`, options);
export const getTermsConditionsPolicy = ({ query = {}, options = null }) =>
	axios.get(`/terms-conditions-policy?${qs.stringify(query)}`, options);
export const postSupport = ({ body = {}, options = null }) => axios.post("/support", body, options);
export const postCheckMaintenance = ({ body = {}, options = null }) => axios.post("/check-maintenance", body, options);
export const getSystems = ({ query = {}, options = null }) => axios.get(`/systems?${qs.stringify(query)}`, options);
export const getGeoFilter = ({ query = {}, options = null }) =>
	axios.get(`/geo-filter?${qs.stringify(query)}`, options);
export const decodeQRCode = ({ body = {}, options = null }) => axios.post("/decode-qr", body, options);
